<template>
    <div>
<!--body content start-->

<div id="main-page" class="page-content">

<!--team start-->

<section>
  <div class="container">
    <div class="row justify-content-center text-center">
      <div class="col-lg-8 col-md-12">
        <div class="section-title">
          <h6>Expert Team</h6>
          <h2 class="title mb-0">Meet Our Expert will ready <span>for your service</span></h2>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <div class="team-member">
          <h5><a href="team-single.html">Jesson<br>Mart</a></h5>
          <div class="team-images">
            <img class="img-fluid box-shadow" src="images/team/01.jpg" alt="">
          </div>
          <div class="team-social-icon">
            <ul>
              <li><a href="#"><i class="fab fa-facebook-f"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-twitter"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-google-plus-g"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-linkedin-in"></i></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-md-4 mt-5 mt-md-0">
        <div class="team-member">
          <h5><a href="team-single.html">Michael<br>Vegas</a></h5>
          <div class="team-images">
            <img class="img-fluid box-shadow" src="images/team/02.jpg" alt="">
          </div>
          <div class="team-social-icon">
            <ul>
              <li><a href="#"><i class="fab fa-facebook-f"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-twitter"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-google-plus-g"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-linkedin-in"></i></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-md-4 mt-5 mt-md-0">
        <div class="team-member">
          <h5><a href="team-single.html">Charlote<br>Kerry</a></h5>
          <div class="team-images">
            <img class="img-fluid box-shadow" src="images/team/03.jpg" alt="">
          </div>
          <div class="team-social-icon">
            <ul>
              <li><a href="#"><i class="fab fa-facebook-f"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-twitter"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-google-plus-g"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-linkedin-in"></i></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-md-4 mt-5">
        <div class="team-member">
          <h5><a href="team-single.html">Jesson<br>Mart</a></h5>
          <div class="team-images">
            <img class="img-fluid box-shadow" src="images/team/01.jpg" alt="">
          </div>
          <div class="team-social-icon">
            <ul>
              <li><a href="#"><i class="fab fa-facebook-f"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-twitter"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-google-plus-g"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-linkedin-in"></i></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-md-4 mt-5">
        <div class="team-member">
          <h5><a href="team-single.html">Michael<br>Vegas</a></h5>
          <div class="team-images">
            <img class="img-fluid box-shadow" src="images/team/02.jpg" alt="">
          </div>
          <div class="team-social-icon">
            <ul>
              <li><a href="#"><i class="fab fa-facebook-f"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-twitter"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-google-plus-g"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-linkedin-in"></i></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-md-4 mt-5">
        <div class="team-member">
          <h5><a href="team-single.html">Charlote<br>Kerry</a></h5>
          <div class="team-images">
            <img class="img-fluid box-shadow" src="images/team/03.jpg" alt="">
          </div>
          <div class="team-social-icon">
            <ul>
              <li><a href="#"><i class="fab fa-facebook-f"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-twitter"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-google-plus-g"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-linkedin-in"></i></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!--team end-->

</div>

<!--body content end--> 

    </div>
</template>

<script>
export default {
    data: function () {
        return {
            name: 'Team',
        }
    },
};
</script>